import { ANT_ASCENDING, API_DESCENDING, API_ASCENDING, ANT_DESCENDING } from 'constants/SortConstants';

/**
 * Converts an ant design table sort constant to an api constant
 */
export const resolveSort = direction => {
  if (direction === ANT_ASCENDING) {
    return API_ASCENDING;
  }
  if (direction === ANT_DESCENDING) {
    return API_DESCENDING;
  }
  return null;
};

export const resolveSortAntd = direction => {
  if (direction === API_ASCENDING) {
    return ANT_ASCENDING;
  }
  if (direction === API_DESCENDING) {
    return ANT_DESCENDING;
  }
  return null;
};

/**
 * @param {Array<import('antd/Array<import('antd/lib/table').ColumnProps')>} columns
 * @param {{[dataIndex: string]?: ANT_ASCENDING | ANT_DESCENDING}} sortConfig
 * @returns {Array<import('antd/Array<import('antd/lib/table').ColumnProps')>}
 */
export const initColumnsWithSorter = (columns, sortConfig) =>
  columns.map(col => ({ ...col, defaultSortOrder: sortConfig[col.dataIndex ?? col.key] ?? col.defaultSortOrder }));
